import React, { useState, useEffect, useContext } from "react";

import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import TableMainSearch from "../common/MainSearch";

import { YearContext } from "../../contexts/yearContext";
import { PopUpContext } from "../../contexts/popUpContext";

import DataTable from "./SubjectList";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import _ from "lodash";

const Subjects = () => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const { entryYear } = useContext(YearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData({ entryYear });

    return () => ac.abort();
  }, [entryYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      let query = `subjects/list`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.Subjects} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainButton
            type="add"
            title={lbl.AddSubject}
            handleClick={() => togglePopUp({ form: "subject-form" })}
          />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} query={query} />
      </div>
    </div>
  );
};

export default Subjects;
